<template>
  <div class="maintain-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">{{ title }}维护记录</div>
      <div class="box">
        <div class="form">
          <el-form
            ref="form"
            :rules="rules"
            :model="addeditInfo"
            label-width="160px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车架号" prop="frame_num">
                  <el-input
                    v-model="addeditInfo.frame_num"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车牌号" prop="license_num">
                  <el-input
                    v-model="addeditInfo.license_num"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="问题描述" prop="problem">
                  <el-input
                    v-model="addeditInfo.problem"
                    type="textarea"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <div v-if="title === '编辑'">
                <el-col :span="12">
                  <el-form-item label="解决方案" prop="solution">
                    <el-input
                      v-model="addeditInfo.solution"
                      type="textarea"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经办人" prop="person">
                  <el-input
                    v-model="addeditInfo.person"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经办人联系电话">
                  <el-input
                    v-model="addeditInfo.phone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button @click="$router.go(-1)">关闭</el-button>
            <el-button type="primary" @click="submitForm('form')"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoleList, SetUserDeatil, GetUserDeatil } from '@/api/user'
import { isPhone } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { selectCompanyData } from '@/api/company'
import { addMaintain, updateMaintain } from '@/api/maintain'
export default {
  data () {
    return {
      id: null,
      edit: true,
      editPerson: true,
      token: getToken(),
      addeditInfo: {
        frame_num: '',
        license_num: '',
        problem: '',
        solution: null,
        person: '',
        phone: ''
      },
      rules: {
        frame_num: [
          { required: true, message: '请输入', trigger: 'change' },
          { min: 17, max: 17, message: '车架号固定长为17位！', trigger: 'blur' }
        ],
        license_num: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        problem: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        solution: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        person: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'change' },
          { pattern: isPhone, message: '请输入正确的手机号!' },
        ],
        dept: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        landline: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        post: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        belong_company: [
          { required: true, message: '请选择所属公司', trigger: 'bur' }
        ]
      },
      options: {
        roleOptions: [],
        companyOptions: []
      },
      companyData: [],
      userRoleData: [],
      URL: process.env.VUE_APP_BASE_API,
      title: '新增'

    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.addeditInfo = this.$route.query
      this.title = '编辑'
    } else {
      this.title = '新增'
    }
    this.getRoleData()
    this.initCompanyData()
  },
  methods: {
    getRoleData () {
      GetRoleList()
        .then(res => {
          if (res.code === 0) {
            this.queryRoleOptions(res.data)
          }
        })
    },
    handleAvatarSuccess (res) {
      if (res.code === 0) {
        this.data.photo = res.data.src
      }
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title === '新增') {
            addMaintain(this.addeditInfo).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功!')
                this.$router.back(-1)
              }
            })
          } else {
            updateMaintain(this.addeditInfo).then(res => {
              if (res.code == 0) {
                this.$message.success('修改成功!')
                this.$router.back(-1)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // //根据角色获取页面角色下拉数据  --角色类型数据options
    queryRoleOptions (roleData) {
      roleData.forEach(el => {
        if (el.level == 1 || el.level == 2 || el.id == 5) {
          if (el.id == 5) {
            el.disabled = true
          } else {
            el.disabled = false
          }
          this.options.roleOptions.push(el)
        }
      })
    },
    // //获取公司树数据
    initCompanyData () {
      selectCompanyData().then(res => {
        this.companyData = res.data
      })
    },
    // //类型选中事件   -- 所属公司数据 companyData
    roleChange () {
      let roleId = this.data.role_id
      this.initCompanySelectData(roleId)
      if (roleId == 5) {
        this.rules.belong_company = [{ required: false, message: '请选择所属公司', trigger: 'bur' }]
      } else {
        this.edit = true
        this.rules.belong_company = [{ required: true, message: '请选择所属公司', trigger: 'bur' }]
      }
    },
    initCompanySelectData (roleId) {
      this.data.belong_company = null
      this.options.companyOptions = []
      if (roleId === 1 || roleId === 3) {
        this.companyData.forEach(el => {
          if (el.company_code == 0) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 6) {
        this.companyData.forEach(el => {
          if (el.company_code == 1) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 7) {
        this.companyData.forEach(el => {
          if (el.company_code == 2) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 2) {
        this.companyData.forEach(el => {
          if (el.company_code == 3) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 5) {
        this.companyData.forEach(el => {
          if (el.company_code == 4) {
            this.options.companyOptions.push(el)
          }
        })
        this.edit = false
        this.rules.belong_company = [{ required: false, message: '请选择所属公司', trigger: 'bur' }]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.maintain-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
        text-align: center;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
          img {
            width: 156px;
            height: 159px;
            display: block;
          }
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        // max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>
